import { FancySpinner } from "../../components/common/fancy-spinner.jsx";

interface ContextMenuLoaderProps {
  loading: boolean;
}

export const ContextMenuLoader = ({ loading }: ContextMenuLoaderProps) => {
  if (!loading) {
    return null;
  }

  return (
    <li className="flex items-center justify-center py-2">
      <FancySpinner size="small" />
    </li>
  );
};
